export default "__VITE_ASSET__DbV7qxua__"